export const licenseKey =
  'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogImRjOGI0NTBhLWVlNjItNDkwNS04MzAxLTRhZTJmOGNjNmFlMiIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjQxCn0=.w7VN2g0J/JuebCHng7APB0DwJLBo+6nHG+X2lG0zFL8pSKgnMb65zo2Xf5cWkEYRWu5/h7ZvseKLdCJqJtdfmGDpWpMYiCFzcmYJMPGB+XpylR/tJ2UnoQcrTovaME/c5LNbRg=='
